import { render, staticRenderFns } from "./datatable_promotion_code.vue?vue&type=template&id=b22d6310"
import script from "./datatable_promotion_code.vue?vue&type=script&lang=js"
export * from "./datatable_promotion_code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports